






























































































import { Component, Vue, Provide, Prop } from "vue-property-decorator";
import { ReduceTicketReq } from "@/pbjs/external/ticket/ticket_pb";
import { ApplyReducePenaltyFieldDetail } from "@/pbjs/xcommon/core_pb";
import { ticketClient } from "@/api";
import { localGet, setMetaData, timeFormat } from "@/utils";
import { setCommon, handleResponse, errorMsg } from "@/utils/request";

@Component({
  name: "newOrder",
})
export default class CombinationProperty extends Vue {
  @Prop() ticketData!: any;
  @Prop() subOrderid!: any;
  @Prop() multi_loan_switch!: any;

  @Provide() private penaltyData: any = [];
  @Provide() private penaltyFee: any = null;
  @Provide() private penaltyServiceFee: any = null;
  @Provide() private penaltyOverdueFee: any = null;
  @Provide() private penaltyFormList: any = [];
  @Provide() private leftamounttotalgroup: string = "";
  @Provide() private leftamounttotalstaff: string = "";
  @Provide() private penaltyFormFillinList: any[] = [];
  @Provide() private isReduceTicketDone: boolean = false;
  @Provide() private penaltyForm: any = {
    interest: null,
    penalty: null,
    reason: "",
  };
  @Provide() private showTimesTips: any = {
    showlefttotaltips: null,
    lefttotalgroup: "",
    lefttotalstaff: "",
    showleftapplyamounttips: "",
    leftapplyamount: "",
  }; //减免次数展示

  private created() {
    this.reduceTicket();
  }

  private resetForm(formName: string) {
    const ref: any = this.$refs[formName];
    ref.resetFields();
  }

  private closeDialog() {
    this.$emit("showDiffTypeDialog", 0);
  }

  private reduceTicketFuc(data: any) {
    this.penaltyData = data.detailList;
    this.penaltyFormList = data.fieldsList;
    // this.penaltyFormList = [{
    //   displayname: "hello",
    //   fieldname: "value"
    // }];
    this.leftamounttotalgroup = data.leftamounttotalgroup;
    this.leftamounttotalstaff = data.leftamounttotalstaff;
    this.penaltyFormFillinList = this.penaltyFormList.map((item: any) => {
      let obj = {} as any;
      obj.displayname = item.displayname;
      obj.fieldname = item.fieldname;
      obj.fieldvalue = "";
      return obj;
    });

    this.showTimesTips = {
      showlefttotaltips: data.showlefttotaltips,
      lefttotalgroup: data.lefttotalgroup,
      lefttotalstaff: data.lefttotalstaff,
      showleftapplyamounttips: data.showleftapplyamounttips,
      leftapplyamount: data.leftapplyamount,
    };
  }
  private async reduceTicket() {

    const { setReduceTicketReq, reduceTicketRequest }: any = await import(
      "@/request/reduceTicket"
    );
    let res = await reduceTicketRequest.handleHttp(
      setReduceTicketReq({
        itemid: this.ticketData.itemid,
        id: this.ticketData.id,
        appname: this.ticketData.appname,
        // Orderid: this.subOrderid,
        orderid: this.multi_loan_switch
          ? this.subOrderid
          : this.ticketData.orderid,
      }),
      this
    );
    if (res && res.right) {
      this.reduceTicketFuc(res);
    }
  }

  private doReduceTicketFuc() {
    this.resetForm("penaltyForm");
    this.closeDialog();
    this.$message({
      type: "success",
      message: "submit successfully!",
    });
  }
  private isLarge() {
    for (let i = 0; i < this.penaltyData.length; i++) {
      if (
        this.penaltyData[i].leftreducevalue <
        this.penaltyFormFillinList[i].fieldvalue
      )
        return true;
    }
  }
  // 减免本金  拆分后接口
  private async doReduceOther() {
    if (!this.isLarge()) {
      this.isReduceTicketDone = true;
      let _arg: any = {
        TicketId: this.ticketData.id,
        ItemId: this.ticketData.itemid,
        Reason: this.penaltyForm.reason,
        penaltyFormFillinList: this.penaltyFormFillinList,
        // orderid: this.subOrderid,
        orderid: this.multi_loan_switch
          ? this.subOrderid
          : this.ticketData.orderid,
      };
      const { getReduceOtherReq, getReduceOtherRequest }: any = await import(
        "@/request/reducePrincipalAndOther"
      );
      let res = await getReduceOtherRequest.handleHttp(
        getReduceOtherReq(_arg),
        this
      );
      if (res && res.right) {
        this.isReduceTicketDone = false;
        this.doReduceTicketFuc();
      } else {
        this.isReduceTicketDone = false;
      }
    } else {
      let _text = this.$tc("OrderStatus.beyondCompareSubmitFailed");
      this.$message({
        type: "error",
        message: _text,
      });
    }
  }
}
